import { Tooltip } from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import flashFill from "@iconify/icons-eva/flash-fill";
import Iconify from "src/components/iconify";
import PropTypes from "prop-types";
import { propuestasApi } from "src/services/propuestasApi";
import { useSnackbar } from "src/components/snackbar";

/**
 * Botón que mejora el texto de un campo usando IA (GPT-4o mini).
 *
 * Props:
 *   text        — texto actual del campo a mejorar
 *   context     — contexto opcional para que la IA entienda mejor el campo
 *   onCorrected — callback(textoMejorado) que actualiza el campo con el resultado
 *   disabled    — deshabilita el botón (ej: cuando el formulario está enviándose)
 */
const AICorrectButton = ({ text, context, onCorrected, disabled }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [mejorarTexto, { isLoading }] = propuestasApi.useMejorarTextoMutation();

  const handleClick = async () => {
    if (!text || text.trim() === "") return;

    try {
      const resultado = await mejorarTexto({
        texto: text,
        ...(context ? { contexto: context } : {}),
      }).unwrap();

      onCorrected(resultado.textoMejorado);
    } catch {
      enqueueSnackbar("No se pudo mejorar el texto. Intenta nuevamente.", {
        variant: "error",
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
      });
    }
  };

  return (
    <Tooltip title="Mejorar redacción con IA">
      <span>
        <LoadingButton
          size="small"
          variant="outlined"
          color="secondary"
          loading={isLoading}
          disabled={disabled || !text || text.trim() === ""}
          onClick={handleClick}
          startIcon={<Iconify icon={flashFill} width={16} height={16} />}
        >
          Mejorar con IA
        </LoadingButton>
      </span>
    </Tooltip>
  );
};

AICorrectButton.propTypes = {
  text: PropTypes.string,
  context: PropTypes.string,
  onCorrected: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AICorrectButton.defaultProps = {
  text: "",
  context: undefined,
  disabled: false,
};

export default AICorrectButton;
